import { gql } from "@/__generated__/gql";

export const CURRENT_USER_ORG = gql(`
  query CurrentUserOrg {
    me {
      id
      officialOrganization {
        id
        uuid
        name
        logo {
          id
          url(size: 24)
        }
        seatsAvailable
      }
    }
  }
`);
